// MSAL Configuration for Microsoft Authentication
// Note: Leave MICROSOFT_CLIENT_ID empty to use demo mode
// Register your app at: https://portal.azure.com/#blade/Microsoft_AAD_RegisteredApps

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID || '', // Leave empty for demo
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MICROSOFT_TENANT_ID || 'common'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true, // Set to true for IE11/Edge
  },
  system: {
    loggerOptions: {
      logLevel: 'Error',
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case 'Error':
            console.error(message);
            return;
          case 'Warning':
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

// Scopes for Microsoft Graph API (basic profile info)
export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read'],
};

// Check if Microsoft OAuth is configured
export const isMicrosoftConfigured = () => {
  return !!process.env.REACT_APP_MICROSOFT_CLIENT_ID && process.env.REACT_APP_MICROSOFT_CLIENT_ID.length > 0;
};

// Check if Microsoft button should be shown (always show, but display config message if not configured)
export const showMicrosoftButton = () => {
  return true; // Always show the button so users know the feature exists
};
